var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"install-filed"},[_c('el-card',_vm._l((_vm.tagList),function(item,idx){return _c('el-button',{key:idx,attrs:{"size":"mini"},on:{"click":function($event){return _vm.$emit('installBtnClick', item)}}},[_vm._v(_vm._s(item.label))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }